"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InnerProductBox = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _components = require("../components");
var _TopIconButtons = require("../components/IconButtons/TopIconButtons");
var _internal = require("../hooks/internal");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const InnerProductBox = () => {
  const onClick = (0, _internal.useOnClick)();
  const {
    brand,
    className,
    code,
    labels,
    name,
    url,
    isLink,
    linkComponent
  } = (0, _internal.useProduct)();
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    labelKey = null,
    title = null
  } = labels?.ppa ?? {};
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ProductBoxRoot, {
    as: linkComponent,
    isLink: isLink,
    className: className,
    href: isLink ? url : undefined,
    "data-testid": getTestId(code),
    onClick: isLink ? onClick : undefined,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ImageWrapper, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TopIconButtons.TopIconButtons, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ProductImage, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.PointsOrDealLabel, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.BottomIconButtons, {})]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Ppa, {
        shouldRenderEmptyLabel: true,
        label: title,
        productCode: code,
        size: "small",
        type: labelKey,
        maxLines: 1
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Rating, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.NamesWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Brand, {
        variant: "caption",
        "data-testid": `${getTestId('brand')}-${code}`,
        children: brand ?? ''
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Name, {
        "data-testid": `${getTestId('name')}-${code}`,
        children: name
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Shades, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SubscriptionLabel, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.PricesSection, {})]
  });
};
exports.InnerProductBox = InnerProductBox;
//# sourceMappingURL=InnerProductBox.js.map